var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Twitter_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.543 6.609c.015.211.015.423.015.636 0 6.507-4.953 14.01-14.01 14.01v-.003A13.94 13.94 0 0 1 0 19.044a9.888 9.888 0 0 0 7.287-2.04 4.93 4.93 0 0 1-4.6-3.42 4.908 4.908 0 0 0 2.223-.085A4.924 4.924 0 0 1 .96 8.673V8.61c.685.382 1.451.593 2.235.617a4.93 4.93 0 0 1-1.524-6.575A13.975 13.975 0 0 0 11.82 7.796a4.93 4.93 0 0 1 8.391-4.49 9.88 9.88 0 0 0 3.127-1.196 4.943 4.943 0 0 1-2.165 2.723A9.793 9.793 0 0 0 24 4.058a10.004 10.004 0 0 1-2.457 2.55Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Twitter_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgTwitter;